import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { generateTypeUrl, mainUrl } from './../../../global-variables';
import { PredefinedDietsResponseModel } from './../../../core/model/generate-response-model';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  generateUrl,
  baseUrl,
  generatePersonalTypeUrl,
  generateOverviewUrl,
  generateDietTypePreviewUrl,
} from 'src/app/global-variables';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import { CalculateResponseModel } from 'src/app/core/model/generate-response-model';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { PlanService } from '../plan-repository/plan.service';
import { LogoutService } from '../user-repository/logout.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GenerateService {
  isDetail = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private userDataService: UserDataService,
    private generateShared: GenerateShared,
    private submitButtonShared: SubmitButtonShared,
    private userRefreshTokenService: UserRefreshTokenService,
    private planService: PlanService,
    private logoutService: LogoutService,
    private location: Location,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  dietTypeSelected(type: string) {
    // console.log('service', type)
    if (this.isDetail) {
      this.generateShared.goal = type;
      this.generateShared.closeOverviewDetailAndChangeDifficulty();
    } else {
      this.routeAnimationShared.showRouteAnimation();
      this.router.navigate([generateUrl + '/' + type]);
    }
  }

  goToGenerate() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generateUrl]);
  }

  activitySelected(id: number) {
    if (this.isDetail) {
      if (id !== -1) {
        this.generateShared.activityLevelTemp = id;
        this.submitButtonShared.activateNextButton(true);
      } else {
        this.submitButtonShared.activateNextButton(false);
      }
    } else {
      if (id !== -1) {
        this.generateShared.activityLevel = id;
        this.generateShared.generateActivateButton(1);
        this.submitButtonShared.activateNextButton(true);
      } else {
        this.generateShared.activityLevel = -1;
        this.generateShared.generateDeactivateButton(1);
        this.submitButtonShared.activateNextButton(false);
      }
    }
  }

  goToOverview() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generateOverviewUrl]);
  }

  goToDietPersonalType() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generatePersonalTypeUrl]);
  }

  goToDietTypePreview() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generateDietTypePreviewUrl]);
  }

  goToDietType() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generateTypeUrl]);
  }

  back() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  backToMenu() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([mainUrl]);
  }

  calculate(
    startWeight: number,
    goal: string,
    activity: string,
    pregnancyDate: number,
    breastFeedingDate: number
  ): Promise<GenericResponse> {
    return this.userDataService.getUser().then((usr) => {
      let response: GenericResponse;
      if (usr.weight && usr.height && usr.sex) {
        const headerDict = this.userDataService.getHeaderDict();
        return this.http
          .post<CalculateResponseModel>(
            baseUrl + 'api/v2/diet/calculate',
            {
              weight: startWeight,
              height: usr.height,
              sex: usr.sex,
              age: usr.birthDate,
              goal,
              activity,
              pregnancyDate,
              breastFeedingDate,
            },
            {
              headers: new HttpHeaders(headerDict),
            }
          )
          .toPromise()
          .then((res) => {
            // console.log('reeessss', res)
            if (res.success) {
              this.generateShared.setCalories(res.calories);
              this.generateShared.calorie = res.calorie;
            }
            response = new GenericResponse(res.success);
            return response;
          })
          .catch((e) => {
            console.log(e.status, e);
            if (e.status === 403 || e.status === 401) {
              this.userRefreshTokenService.refreshToken().then((resp) => {
                if (resp.isSuccess()) {
                  this.calculate(
                    startWeight,
                    goal,
                    activity,
                    pregnancyDate,
                    breastFeedingDate
                  );
                }
              });
            }
            // alert(JSON.stringify({ line: 163, e }));

            response = new GenericResponse(
              false,
              new GenericResponseData({ message: 'خطای اتصال' })
            );
            return response;
          });
      } else {
        this.logoutService.logout();
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'اطلاعات پروفایل نادرست است' })
        );
        return response;
      }
    });
  }

  generate(
    dietTypeId: string,
    startWeight: number,
    startDate: number,
    selectedCalorie: number,
    goal: string,
    activity: string,
    difficulty: string,
    pregnancyDate: number,
    breastFeedingDate: number,
    specialTypes: string[],
    diseases: string[],
    hatedFoods: string[],
    fastingDays: number[]
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<CalculateResponseModel>(
        baseUrl + 'api/v2/diet/generate',
        {
          dietTypeId,
          startWeight,
          startDate,
          selectedCalorie,
          goal,
          activity,
          difficulty,
          pregnancyDate,
          breastFeedingDate,
          specialTypes,
          diseases,
          hatedFoods,
          fastingDays,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        // console.log('generate res ', res)
        if (res.success) {
          return this.planService.getDietListAndRefreshDB().then((r) => {
            if (r.isSuccess) {
              response = new GenericResponse(res.success);
              return response;
            } else {
              this.logoutService.logout();
              return new GenericResponse(false);
            }
          });
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.generate(
                dietTypeId,
                startWeight,
                startDate,
                selectedCalorie,
                goal,
                activity,
                difficulty,
                pregnancyDate,
                breastFeedingDate,
                specialTypes,
                diseases,
                hatedFoods,
                fastingDays
              );
            }
          });
        }
        // alert(JSON.stringify({ line: 258, e }));

        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  generatePredefined(
    startWeight: number,
    startDate: number,
    activity: string,
    preDefinedId: string
  ): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<CalculateResponseModel>(
        baseUrl + 'api/v2/preDefinedDiet/generate',
        {
          startWeight,
          startDate,
          preDefinedId,
          activity,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        // alert(
        //   JSON.stringify({
        //     line: 294,
        //     res,
        //     startWeight,
        //     startDate,
        //     activity,
        //     preDefinedId,
        //   })
        // );

        // console.log('generate res ', res)
        if (res.success) {
          return await this.planService.getDietListAndRefreshDB().then((r) => {
            if (r.isSuccess) {
              response = new GenericResponse(res.success);
              return response;
            } else {
              this.logoutService.logout();
              return new GenericResponse(false);
            }
          });
        }
        return new GenericResponse(true);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.generatePredefined(
                startWeight,
                startDate,
                activity,
                preDefinedId
              );
            }
          });
        }
        // alert(
        //   JSON.stringify({
        //     line: 319,
        //     e,
        //     startWeight,
        //     startDate,
        //     activity,
        //     preDefinedId,
        //   })
        // );

        response = new GenericResponse(true);

        return response;
      });
  }

  getPredefinedDiets(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<PredefinedDietsResponseModel>(
        baseUrl + 'api/v2/preDefinedDiet/list',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ predefinedDietsResponse: res })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPredefinedDiets();
            }
          });
        }
        // alert(JSON.stringify({ line: 354, e }));

        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getFastingDaysArray(fastingDays: string[]): number[] {
    let fd = [];
    fastingDays.forEach((f) => {
      switch (f) {
        case 'شنبه':
          fd.push(1);
          break;
        case 'یکشنبه':
          fd.push(2);
          break;
        case 'دوشنبه':
          fd.push(3);
          break;
        case 'سه‌شنبه':
          fd.push(4);
          break;
        case 'چهارشنبه':
          fd.push(5);
          break;
        case 'پنجشنبه':
          fd.push(6);
          break;
        case 'جمعه':
          fd.push(7);
          break;
        default:
          break;
      }
    });
    return fd;
  }
}
